/*
 * yotpo-live-rating.js
 * Populates the theme's custom star-rating markup (.product__section--rating-wrapper)
 * with LIVE data from Yotpo's public API, so collection cards / quickview / PDP always
 * match the Yotpo product-page widget. Replaces the unreliable yotpo.* metafields, which
 * go stale on duplicated products and lag for brand-new reviews.
 *
 * Placeholders are rendered `hidden` (display:none) and unhidden only when reviews exist,
 * so zero-review cards keep no gap. Because hidden elements never intersect, loading is
 * EAGER (no IntersectionObserver) — responses are tiny and CDN-cached.
 */
(function () {
  var APP_KEY = '24Ofsw45U51BUg0YnXKJ8zaraSyMzQeg6QxNLyTI';
  var RATING_MAX = 5;
  // v3 storefront API — the SAME endpoint the Yotpo PDP widget uses, including
  // grouped reviews (reviews pooled across related products). The older v1
  // /products/{id}/reviews.json excludes grouping and undercounts (e.g. 7 vs 9).
  var ENDPOINT = 'https://api-cdn.yotpo.com/v3/storefront/store/' + APP_KEY + '/product/';

  function buildMarkup(avg, count) {
    var floor = Math.floor(avg);
    var dec = avg - floor;
    var ratingDecimal = 0;
    if (dec >= 0.3 && dec <= 0.7) ratingDecimal = 0.5;
    else if (dec > 0.7) ratingDecimal = 1;
    var display = (Math.round(avg * 10) / 10).toFixed(1);
    var label = display + ' out of ' + RATING_MAX + ' stars, ' + count + ' review' + (count === 1 ? '' : 's');
    return (
      '<div class="product__section-rating" role="img" aria-label="' + label + '">' +
        '<span aria-hidden="true" class="product__section-rating-star color-icon" ' +
        'style="--rating: ' + floor + '; --rating-max: ' + RATING_MAX + '; --rating-decimal: ' + ratingDecimal + ';"></span>' +
      '</div>' +
      '<p class="product__section-rating-text caption"><span aria-hidden="true">' + display + ' / ' + RATING_MAX + '</span></p>' +
      '<p class="product__section-rating-count caption"><span aria-hidden="true">(' + count + ')</span>' +
        '<span class="visually-hidden">' + count + ' total reviews</span></p>'
    );
  }

  function load(el) {
    var id = el.getAttribute('data-product-id');
    if (!id || el.dataset.yotpoLoaded) return;
    el.dataset.yotpoLoaded = '1';
    fetch(ENDPOINT + id + '/reviews?page=1&perPage=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var bl = d && d.bottomline;
        var count = bl ? parseInt(bl.totalReview, 10) : 0;
        var avg = bl ? parseFloat(bl.averageScore) : 0;
        if (count > 0 && avg > 0) {
          el.innerHTML = buildMarkup(avg, count);
          el.removeAttribute('hidden');
        }
        // no reviews -> stays hidden (matches live Yotpo: nothing shown)
      })
      .catch(function () {
        el.removeAttribute('data-yotpo-loaded'); // allow retry on next scan after a network blip
      });
  }

  function scan(root) {
    var els = (root || document).querySelectorAll('.js-yotpo-live-rating[data-product-id]:not([data-yotpo-loaded])');
    Array.prototype.forEach.call(els, load);
  }

  function init() { scan(document); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-scan for cards added via AJAX (quickview, predictive search, infinite scroll, section reloads)
  document.addEventListener('shopify:section:load', function () { scan(document); });
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length) { scan(document); break; }
    }
  });
  function startMO() { mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) startMO();
  else document.addEventListener('DOMContentLoaded', startMO);
})();
